<mat-dialog-content>
  @if (pickedPhoto$ | async; as pickedPhoto) {
    <lib-single-photo-cropper
      [containerRatio]="containerRatio"
      [contextId]="contextId"
      [imagesContext]="imagesContext"
      [pickedPhoto]="pickedPhoto"
    [ngStyle]="{
      'aspect-ratio': containerRatio
    }"
      (sharpCrop)="currentValue = $event"
      [currentCropValue]="$safeNavigationMigration(tabloMember$?.value?.photo?.handCrop?.crop)"
    ></lib-single-photo-cropper>
  }
  @if (photosToShow$ | async) {
    <lib-virtual-scroll
      [barOverContent]="true"
      [gridItemSize]="150"
      [hasSort]="false"
      [inlineWidthOnRender]="false"
      [isFull]="false"
      [itemTpl]="photo"
      [photos]="photos$ | async"
      itemIndex="photoInGroupId"
      type="grid"
      >
    </lib-virtual-scroll>
  }
  <ng-template #photo let-index let-photo>
    <lib-image-loader
      [ngClass]="{
        picked: photo.photo.photo.photoId === (pickedPhotoId$ | async)
      }"
      (click)="pickedPhotoId$.next(photo.photo.photo.photoId)"
      [disableLoader]="true"
      [url]="
        {
          photoId: photo.photo.photo.photoId
        }
          | getImageUrl
            : photo.photo.groupId
            : 'photographer'
            : imagesContext
            : contextId
            : 600
          | async
      "
    [isCover]="true"
  ></lib-image-loader>
</ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <lib-button (click)="save()"> Zapisz </lib-button>
</mat-dialog-actions>
